export const ord = () => {
  const ords = document.querySelectorAll('.ord__wrapper')

  if (ords?.length > 0) {
    ords.forEach((ord) => {
      const btn = ord.querySelector('.ord__btn')
      const close = ord.querySelector('.ord__close')
      const info = ord.querySelector('.ord__info')

      if (btn && info) {
        btn.addEventListener('click', () => {
          info.classList.add('ord__info_open')
        })
      }

      if (close && info) {
        close.addEventListener('click', () => {
          info.classList.remove('ord__info_open')
        })
      }
    })
  }
}
